import { c as _c } from "react/compiler-runtime";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/radix/tooltip";
import React from "react";
export const DistanceTooltip = React.memo(function DistanceTooltip(t0) {
  const $ = _c(9);
  const {
    distance,
    distanceFromText
  } = t0;
  let t1;
  if ($[0] !== distance) {
    t1 = distance < 1000 ? `${distance}m` : `${(distance / 1000).toFixed(1)}km`;
    $[0] = distance;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const displayDistance = t1;
  const tooltipText = `Geographical distance from ${distanceFromText || "current property/location"}`;
  let t2;
  if ($[2] !== displayDistance) {
    t2 = <TooltipTrigger asChild={true}><span className="ml-auto text-xs bg-white/20 px-2 py-1 rounded-full cursor-help">{displayDistance}</span></TooltipTrigger>;
    $[2] = displayDistance;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== tooltipText) {
    t3 = <TooltipContent side="left"><p>{tooltipText}</p></TooltipContent>;
    $[4] = tooltipText;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <Tooltip>{t2}{t3}</Tooltip>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
});